import { Form } from 'antd';
import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { SetSchedules } from './SetSchedules';
import { StockAddToDo } from './StockAddToDo';
import { StockEdit } from './StockEdit';
import { StockList } from './StockList';

const WrappedAdvancedSearchForm = Form.create()(StockAddToDo);
export const Stock = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={StockList} />
    <Route path={`${props.match.path}/:id/schedules/course/:courseId`} component={SetSchedules} />
    <Route path={`${props.match.path}/:id/update`} component={StockEdit} />
    <Route path={`${props.match.path}/create`} component={WrappedAdvancedSearchForm} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/stock/Stock.tsx